import { Middleware } from 'redux'

import { trackPage } from '../actions/page'
import { LOCATION_CHANGE } from '~/redux-modules/dfm-layers/constants'

export default (): Middleware => () => next => action => {
    if (action.type === LOCATION_CHANGE) {
        // TODO: add "referrer" here as the previous location OR the document.referrer if
        //       there is no previous location.
        return next(trackPage(action))
    }
    return next(action)
}
